import { Fragment, useState } from "react"
import {
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    makeStyles,
    Paper,
    Tooltip,
    TablePagination, 
    Box, 
    Collapse,  
    IconButton, 
  } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { FormatoFechaIso } from "../../../utils/FormatFecha";
import { formatDinero } from "../../../utils/formatDinero";
import { CheckCircle } from "@material-ui/icons";
import BExtraVuelo from "../TProveedorVuelos/BExtraVuelo";
import FExtraVuelo from "../FExtraVuelo";
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck";
import { 
    obtenerEscalasVueloAction,
    obtenerEscalasVueloRegresoAction,
    obtenerPaginaVuelosPorCircuitoAction, 
    obtenerRegistrosVuelosPorCircuitoAction, 
} from "../../../ducks/proveedorAereolineaDuck";
import FAProveedoresVuelos from "../FAProvedoresVuelos";
import BEscalasVuelos from "../TEscalasVuelos/BEscalasVuelos";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FlightLandIcon from '@material-ui/icons/FlightLand';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import FlightIcon from '@material-ui/icons/Flight';
import GroupIcon from '@material-ui/icons/Group';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import EventSeatIcon from '@material-ui/icons/EventSeat';

import FEscalasVuelos from "../FEscalasVuelos";
import PublicIcon from '@material-ui/icons/Public';
import RutaVuelo from "../TEscalasVuelos/RutaVuelo";

const classes= makeStyles({
    root: {
        width: '100%'
    },
    container: {
        display: "block",
    },
    paragraph: {
        display: "flex", 
        alignItems: "flex-end", 
        justifyItems: "center"
    },
    paragraphIcon: {
        marginRight: "0.5rem",
    },
})

const VueloRow = ({ vuelo }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen(!open);

        if (!open) {
            // Solo si se abre, dispara la carga de escalas del vuelo correspondiente
            const payload = { idVueloProveedor: vuelo?.IdVueloProveedor };
            dispatch(obtenerEscalasVueloAction(payload));

            if (vuelo?.EsRedondo) {
                const regresoPayload = { idVueloRedondo: vuelo?.VueloRedondo?.IdVueloRedondo };
                dispatch(obtenerEscalasVueloRegresoAction(regresoPayload));
            }
        }
    };

    return (
        <Fragment>
            <TableRow key={vuelo?.ClaveVuelo}>
                <TableCell align="center">{vuelo?.ClaveVuelo}</TableCell>
                <TableCell align="center">{vuelo?.Origen?.Descripcion}</TableCell>
                <TableCell align="center">{vuelo?.Destino?.Descripcion}</TableCell>
                <TableCell align="center">
                    <Tooltip title={vuelo?.EsRedondo ? "Redondo" : "Ordinario"}>
                        <CheckCircle color={vuelo?.EsRedondo ? "secondary" : "action"} />
                    </Tooltip>
                </TableCell>
                <TableCell align="center">
                    <BEscalasVuelos vuelo={vuelo} />
                    <FEscalasVuelos  />
                </TableCell>
                <TableCell align="center">
                    <BExtraVuelo vuelo={vuelo} />
                    <FExtraVuelo />
                </TableCell>
                <TableCell align="center">
                    <FAProveedoresVuelos vuelo={vuelo} />
                </TableCell>

                <TableCell>
                    <IconButton size="large" onClick={handleToggle}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box style={{ display: open ? "block" : "none" }}>
                            <p style={{ display: "flex", alignItems: "flex-end" }}>
                                <RutaVuelo vuelo={vuelo} esRedondo={false} />
                            </p>

                            <p style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                                <PublicIcon color="primary" style={{ marginRight: "0.5rem" }} />
                                <strong>Región de vuelo:</strong>&nbsp;
                                {(!vuelo?.CatRegion || vuelo?.CatRegion?.IdCatRegion <= 0)
                                    ? "No hay una región asignada"
                                    : vuelo?.CatRegion?.Descripcion
                                }
                            </p>

                            <p style={{ display: "flex", alignItems: "center" }}>
                                <FlightIcon color="primary" style={{ marginRight: "0.5rem" }} />
                                <strong>Proveedor:</strong>&nbsp;{vuelo?.Proveedor?.RazonSocial}
                            </p>

                            <p style={{ display: "flex", alignItems: "center" }}>
                                <MonetizationOnIcon color="primary" style={{ marginRight: "0.5rem" }} />
                                <strong>Precio:</strong>&nbsp;{formatDinero(vuelo?.PrecioNeto)} {vuelo?.Moneda?.Clave}
                            </p>

                            <p style={{ display: "flex", alignItems: "center" }}>
                                <EventSeatIcon color="primary" style={{ marginRight: "0.5rem" }} />
                                <strong>Clase de vuelo:</strong>&nbsp;
                                {vuelo?.CatVueloClase.IdCatVueloClase > 0
                                    ? vuelo?.CatVueloClase?.Descripcion
                                    : "No hay una clase de vuelo asignada"
                                }
                            </p>

                            <p style={{ display: "flex", alignItems: "center" }}>
                                <GroupIcon color="primary" style={{ marginRight: "0.5rem" }} />
                                <strong>Disponibilidad:</strong>&nbsp;{vuelo?.Disponibilidad}
                            </p>

                            <p style={{ display: "flex", alignItems: "center" }}>
                                <FlightTakeoffIcon color="primary" style={{ marginRight: "0.5rem" }} />
                                <strong>Salida:</strong>&nbsp;{FormatoFechaIso({ date: vuelo?.FechaSalida, formato: "dd/MM/yyyy HH:mm" })}
                            </p>

                            <p style={{ display: "flex", alignItems: "center" }}>
                                <FlightLandIcon color="primary" style={{ marginRight: "0.5rem" }} />
                                <strong>Llegada:</strong>&nbsp;{FormatoFechaIso({ date: vuelo?.FechaLlegada, formato: "dd/MM/yyyy HH:mm" })}
                            </p>

                            <p style={{ display: "flex", alignItems: "center" }}>
                                <strong>Es redondo:</strong>&nbsp;
                                <Tooltip title={vuelo?.EsRedondo ? "Redondo" : "Ordinario"}>
                                    <CheckCircle color={vuelo?.EsRedondo ? "secondary" : "action"} style={{ marginLeft: "0.5rem" }} />
                                </Tooltip>
                            </p>

                            {vuelo?.EsRedondo && (
                                <Fragment>
                                    <p style={{ display: "flex", alignItems: "center" }}>
                                        &emsp;<RutaVuelo vuelo={vuelo?.VueloRedondo} esRedondo={true} />
                                    </p>

                                    <p style={{ display: "flex", alignItems: "center" }}>
                                        &emsp;<EventSeatIcon color="secondary" style={{ marginRight: "0.5rem" }} />
                                        <strong>Clase de vuelo:</strong>&nbsp;
                                        {vuelo?.VueloRedondo?.CatVueloClase?.IdCatVueloClase > 0
                                            ? vuelo?.VueloRedondo?.CatVueloClase?.Descripcion
                                            : "No hay una clase de vuelo asignada"
                                        }
                                    </p>

                                    <p style={{ display: "flex", alignItems: "center" }}>
                                        &emsp;<FlightTakeoffIcon color="secondary" style={{ marginRight: "0.5rem" }} />
                                        <strong>Salida Redondo:</strong>&nbsp;
                                        {FormatoFechaIso({ date: vuelo?.VueloRedondo?.FechaSalida, formato: "dd/MM/yyyy HH:mm" })}
                                    </p>

                                    <p style={{ display: "flex", alignItems: "center" }}>
                                        &emsp;<FlightLandIcon color="secondary" style={{ marginRight: "0.5rem" }} />
                                        <strong>Llegada Redondo:</strong>&nbsp;
                                        {FormatoFechaIso({ date: vuelo?.VueloRedondo?.FechaLlegada, formato: "dd/MM/yyyy HH:mm" })}
                                    </p>
                                </Fragment>
                            )}
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
};

const TablaVuelos = () => {
    const dispatch = useDispatch();
    const { circuitoSelect } = useSelector(store => store.proveedorTerrestre);
    const { 
        vuelosPorCircuito, 
        totalVuelosPorCircuito, 
        paginaVuelosPorCircuito, 
        registrosVuelosPorCircuito 
    } = useSelector(store => store.vueloProveedor);
    
    const rows = vuelosPorCircuito ?? [];

    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerPaginaVuelosPorCircuitoAction({ 
            idPaqueteCircuito: circuitoSelect?.IdPaqueteCircuito, 
            pagina: newPage 
        })).then(() => {
            dispatch(offLoadAction())
        })
    }

    const handleChangeRowsPerPage = (event) => {
        const rowsPerPage = +event.target.value;
     
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerRegistrosVuelosPorCircuitoAction({ 
            idPaqueteCircuito: circuitoSelect?.IdPaqueteCircuito,
            registros: rowsPerPage
        })).then(() => {
            dispatch(offLoadAction())
        })
    }

    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container} style={{maxHeight: "350px", overflow: "scroll"}}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Clave</TableCell>
                        <TableCell align="center">Origen</TableCell>
                        <TableCell align="center">Destino</TableCell>
                        <TableCell align="center">Es redondo</TableCell>
                        <TableCell align="center">Escalas</TableCell>
                        <TableCell align="center">Extras</TableCell>
                        <TableCell align="center">Editar</TableCell>
                        <TableCell align="center">Detalles</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {rows.length > 0 ? rows.map((row) => (
                       <VueloRow key={row?.IdVueloProveedor} vuelo={row} />
                    )) : (
                        <TableRow>
                            <TableCell colSpan={6}>No hay vuelos registrados</TableCell>
                        </TableRow>
                    )}

                </TableBody>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={totalVuelosPorCircuito}
                rowsPerPage={registrosVuelosPorCircuito}
                page={paginaVuelosPorCircuito}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    )
}

export default TablaVuelos;